import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { NotificationProgressInfo } from './progress-notification.interfaces';

export class SignalrWindow extends Window {
    $: any;
}

export enum ConnectionState {
    Connecting = 1,
    Connected = 2,
    Reconnecting = 3,
    Disconnected = 4
}

export class NotificationMessage {
    name: string;
    groupName: string;
    payload: NotificationProgressInfo | any ;

    constructor() {
    }
}



export class NotificationConfig {
    url: string;
    hubName: string;
}

export class NotificationSubject {
    groupName: string;
    subject: Subject<NotificationMessage>;
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/server-notification/service-notification.interfaces.ts